module.exports = __webpack_public_path__ + "static/media/wave.cc6d806e.svg";